import React from 'react';
import { ShieldCheckIcon, CheckCircleIcon } from 'lucide-react';
export const TrustSection = () => {
  return <section className="py-16 bg-gray-50 dark:bg-[#0A1C1A] transition-colors duration-300" data-id="element-2944">
      <div className="container mx-auto px-4 md:px-6" data-id="element-2945">
        <div className="text-center mb-12" data-id="element-2946">
          <h2 className="text-3xl font-bold mb-4 inline-flex items-center gap-2 text-[#0F3B46] dark:text-[#F8FAF9]" data-id="element-2947">
            <span className="text-2xl" data-id="element-2948">✨</span>
            <span data-id="element-2949">Trusted by Creators Worldwide</span>
          </h2>
          <p className="text-lg text-gray-600 dark:text-[#B0C1BD] max-w-2xl mx-auto" data-id="element-2950">
            Built by creators, for creators. Every template, tool, and pack is
            hand-picked for quality and safety.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto" data-id="element-2951">
          {[{
          icon: <ShieldCheckIcon className="h-8 w-8 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-2952" />,
          title: '100% Secure Downloads',
          description: 'All files are scanned and verified for security'
        }, {
          icon: <CheckCircleIcon className="h-8 w-8 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-2953" />,
          title: 'Manually Reviewed',
          description: 'Our team reviews every submission for quality'
        }, {
          icon: <div className="h-8 w-8 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-2954" />,
          title: '80% Earnings to Creators',
          description: 'We offer one of the highest revenue shares'
        }, {
          icon: <div className="h-8 w-8 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-2955" />,
          title: 'Instant Access',
          description: 'Get your files immediately after purchase'
        }].map((item, index) => <div key={index} className="bg-white dark:bg-[#162825] p-6 rounded-xl shadow-sm border border-gray-100 dark:border-[#1A3330] hover:shadow-md transition-all duration-300 text-center" data-id="element-2956">
              <div className="bg-gray-50 dark:bg-[#1A3330] w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2957">
                {item.icon}
              </div>
              <h3 className="text-lg font-semibold mb-2 text-gray-800 dark:text-[#F8FAF9]" data-id="element-2958">
                {item.title}
              </h3>
              <p className="text-gray-600 dark:text-[#B0C1BD] text-sm" data-id="element-2959">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};